import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  Drawer,
  FormControlLabel,
  Grid2,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import React, { useEffect, useState } from "react";
import { colors } from "../../theme/theme";
import { SecondaryBtn } from "../../Components/Common/CustomBtn";
import { ArrowBack, Close, ArrowForward } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { CustomInputLabel } from "../../Components/Creators/CustomInputLabel";
import {
  CustomTextArea,
  CustomInput,
} from "../../Components/Common/CustomInput";
import {
  getAllPosts,
  subscribeToContent,
} from "../../redux/actions/posts.dispatcher";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";
import { getSubscriptionOfUser } from "../../redux/actions/subscriptions.dispatcher";
import {
  createExerciseEvent,
  updateExerciseEvent,
} from "../../redux/actions/user.dispatcher";

import FileUpload from "../../Components/Common/FileUpload";
import { CustomDropDown } from "../../Components/Common/CustomDropdown";
import Layout from "../../layouts/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomCheckbox } from "../../Components/Common/CustomCheckbox";

const interestLabels = {
  jiuJitsu: "Jiu-Jitsu",
  boxing: "Boxing",
  muaythai: "Muay Thai",
  wrestling: "Wrestling",
  kickboxing: "Kickboxing",
  mma: "MMA Training",
  strength: "Strength & Conditioning",
  mental: "Mental & Recovery",
  fighter: "Fighter Lifestyle",
};

const CreateExerciseEvent = ({}) => {
  const location = useLocation();
  const { event } = location?.state;
  const { userData } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [uploadUrl, setUploadUrl] = useState(null);
  const [fullName, setFullName] = useState(userData?.firstName || "");
  const [email, setEmail] = useState(userData?.email || "");
  const [cardHolderName, setcardHolderName] = useState("");
  const [cardNumber, setcardNumber] = useState("");
  const [expiryDate, setexpiryDate] = useState("");
  const [cvv, setcvv] = useState("");
  const navigate = useNavigate();

  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [eventFormData, setEventFormData] = useState({
    userId: userData.id,
    name: "",
    description: "",
    category: [],
    plan: "",
    price: "",
    participants: "",
    deadline: null,
    startDateTime: null,
    endDate: null,
    oneTimeEvent: true, // ✅ Default to a one-time event
    recurrenceType: "", // ✅ "daily" | "weekly" | "byDate"
    recurrenceEndDate: null, // ✅ When the recurring event stops
  });

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleUpdateEvent = async () => {
    setErrorState({ error: false, message: "" });

    try {
      setLoading(true);

      let id;
      if (event.parentEventId) {
        id = event.parentEventId;
      } else {
        id = event.id;
      }

      const response = await updateExerciseEvent(id, {
        ...eventFormData,
        mediaURL: uploadUrl,
      });
      if (response) {
        setEventFormData({
          userId: userData.id,
          name: "",
          description: "",
          category: [],
          plan: "",
          duration: "",
          price: "",
          participants: "",
          deadline: null,
          startDateTime: null,
          endDate: null,
          oneTimeEvent: true,
          recurrenceType: "",
          recurrenceEndDate: null,
        });
      }
    } catch (error) {
      console.log(error);
      setErrorState({ error: true, message: error.message });
    } finally {
      setLoading(false);
      navigate("/calendar");
    }
  };

  const handleCreateEvent = async () => {
    setErrorState({ error: false, message: "" });
    if (!eventFormData.name || !eventFormData.description) {
      setErrorState({
        error: true,
        message: "Required fields cannot be empty",
      });
      return;
    }

    try {
      setLoading(true);

      const response = await createExerciseEvent({
        ...eventFormData,
        mediaURL: uploadUrl,
      });
      if (response) {
        setEventFormData({
          userId: userData.id,
          name: "",
          description: "",
          category: [],
          plan: "",
          duration: "",
          price: "",
          participants: "",
          deadline: null,
          startDateTime: null,
          endDate: null,
          oneTimeEvent: true,
          recurrenceType: "",
          recurrenceEndDate: null,
        });
      }
    } catch (error) {
      console.log(error);
      setErrorState({ error: true, message: error.message });
    } finally {
      setLoading(false);
      navigate("/calendar");
    }
  };

  const handleEventFormChange = (field, value) => {
    setEventFormData({ ...eventFormData, [field]: value });
  };

  const mediumScreen = useMediaQuery("(max-width:960px)");

  useEffect(() => {
    if (event) {
      setEventFormData({
        userId: userData.id,
        name: event.title || "",
        description: event.description || "",
        category: event.categories || [],
        plan: event.plan || "",
        price: event.price || "",
        participants: event.participants || "",
        deadline: event.deadline ? dayjs(event.deadline) : null,
        startDateTime: event.startDateTime ? dayjs(event.startDateTime) : null,
        endDate: event.endDate ? dayjs(event.endDate) : null,
        oneTimeEvent: !event.recurrenceType, // If no recurrenceType, then treat as one-time
        recurrenceType: event.recurrenceType || "",
        recurrenceEndDate: event.recurrenceEndDate
          ? dayjs(event.recurrenceEndDate)
          : null,
      });

      if (event.mediaURL) {
        setUploadUrl(event.mediaURL);
      }
    }
  }, [event]);
  return (
    <Layout>
      {event.parentEventId && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            backgroundColor: "#FFF3CD", // soft yellow
            border: "1px solid #FFECB5",
            padding: "12px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <Typography
            sx={{ color: "#856404", fontSize: "14px", textAlign: "center" }}
          >
            ⚠️ This is a Recreated Training. Editing the contents of this won’t
            affect the base Training or upcoming trainings.
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          "& .MuiDrawer-paper": {
            width: "75%",
            border: "1px solid #000",
            backgroundColor: "#fff",
          },
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {/* Snackbar */}
        <ErrorSnackbar
          error={errorState.error}
          handleCloseError={() => setErrorState({ error: false, message: "" })}
          errorMsg={errorState.message}
        />
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              px: 2,
              py: 2,
            }}
          >
            <IconButton
              onClick={() => {
                navigate("/calendar");
              }}
            >
              <ArrowBack sx={{ color: "#000", opacity: 1 }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: "23px",
                fontFamily: "Inter-SemiBold",
                color: colors.textColor,
              }}
            >
              Create Training Content
            </Typography>
          </Box>

          <Grid2 container spacing={2} sx={{ mt: 3, px: 4, pb: 4 }}>
            <Grid2 item size={{ xs: 12, md: 3 }}>
              <CustomInputLabel text="Upload Media" />
              <FileUpload
                fileType="any"
                setUploadUrl={setUploadUrl}
                uploadUrl={uploadUrl}
                setLoading={setLoading}
              />
            </Grid2>
            <Grid2 item size={{ xs: 12, md: 9 }}>
              <Grid2 container spacing={mediumScreen ? 0 : 2}>
                <Grid2 item size={{ xs: 12, md: 12 }}>
                  <CustomInputLabel text="Title" required />
                  <CustomInput
                    value={eventFormData.name}
                    setValue={(value) => handleEventFormChange("name", value)}
                    noIcon
                    placeholder="e.g., Arm-Bar Drills"
                  />
                </Grid2>
              </Grid2>
              <Grid2 container spacing={mediumScreen ? 0 : 2}></Grid2>
              <Box>
                <CustomInputLabel text="Description" required />
                <CustomTextArea
                  noIcon
                  value={eventFormData.description}
                  limit={150}
                  setValue={(value) =>
                    handleEventFormChange("description", value)
                  }
                  placeholder="e.g. Drawing Added: Circle around kick target."
                />
              </Box>
              <Grid2 container spacing={2}>
                {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Skill Level" required />
                  <CustomDropDown
                    value={eventFormData.level}
                    setValue={(value) => handleEventFormChange("level", value)}
                    title="e.g. Beginner, Intermediate, Advanced"
                    label="e.g. Beginner, Intermediate, Advanced"
                    data={[
                      { id: 1, label: "Beginner", value: "Beginner" },
                      { id: 2, label: "Intermediate", value: "Intermediate" },
                      { id: 3, label: "Advanced", value: "Advanced" },
                    ]}
                    noIcon
                    noMt
                  />
                </Grid2> */}

                <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Category" required />
                  <CustomCheckbox
                    options={Object.values(interestLabels)} // e.g., ["Muay Thai", "MMA Training"]
                    selectedValues={eventFormData.category}
                    onChange={(selected) =>
                      handleEventFormChange("category", selected)
                    }
                    multiple
                  />
                </Grid2>
                {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Duration" required />
                  <CustomDropDown
                    value={eventFormData.duration}
                    setValue={(value) =>
                      handleEventFormChange("duration", value)
                    }
                    title="e.g. 5, 10, 15, 30 minutes, etc"
                    label="e.g. 5, 10, 15, 30 minutes, etc"
                    data={[
                      { id: 1, label: "5 minutes", value: "5 minutes" },
                      { id: 2, label: "10 minutes", value: "10 minutes" },
                      { id: 3, label: "15 minutes", value: "15 minutes" },
                      { id: 3, label: "30 minutes", value: "30 minutes" },
                    ]}
                    noIcon
                    noMt
                  />
                </Grid2> */}
                {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Subscription" required />
                  <CustomDropDown
                    value={eventFormData.plan}
                    setValue={(value) => handleEventFormChange("plan", value)}
                    title="e.g. Free, Paid, VIP Access"
                    label="e.g. Free, Paid, VIP Access"
                    data={[

                      { value: "freeToEveryone", label: "Free to everyone" },

                      {
                        value: "payPerViewToEveryone",
                        label: "Pay per View for everyone",
                      },
                      {
                        value: "payPerView",
                        label: "Pay Per View only for subscriber",
                      },
                      { value: "paid", label: "Paid - only for subscribers" },
                    ]}
                    noIcon
                    noMt
                  />
                </Grid2>
                {(eventFormData.plan === "payPerView" ||
                  eventFormData.plan === "payPerViewToEveryone") && (
                  <Grid2 item size={{ xs: 12, md: 6 }}>
                    <CustomInputLabel text="Price" required />

                    <CustomInput
                      value={eventFormData.price}
                      setValue={(value) =>
                        handleEventFormChange("price", value)
                      }
                      noIcon
                      placeholder="e.g., 2"
                    />
                  </Grid2>
                )} */}
                {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Enrollment Deadline" required />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={eventFormData.deadline} // Bind value to state
                      onChange={(value) =>
                        handleEventFormChange("deadline", value)
                      }
                      sx={{
                        height: "52.5px",
                        width: "100%",
                        borderRadius: "0px",
                        border: "1px solid #000",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "transparent",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "transparent",
                          borderWidth: "0px",
                        },
                        "& .MuiSelect-icon": {
                          color: "#00000080",
                        },
                        "& .Mui-focused": {
                          borderColor: "transparent",
                          border: "none",
                        },
                        "& .MuiInputAdornment-root": {
                          color: "#00000080",
                        },
                        fontFamily: "Inter-Regular",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    />
                  </LocalizationProvider>
                </Grid2> */}
                {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Max Participants" required />
                  <CustomDropDown
                    value={eventFormData.participants}
                    setValue={(value) =>
                      handleEventFormChange("participants", value)
                    }
                    title="e.g. 5, 10, 15, 20 participants"
                    label="e.g. 5, 10, 15, 20 participants"
                    data={[
                      {
                        id: 1,
                        label: "5 participants",
                        value: "5 participants",
                      },
                      {
                        id: 1,
                        label: "10 participants",
                        value: "10 participants",
                      },
                      {
                        id: 1,
                        label: "15 participants",
                        value: "15 participants",
                      },
                      {
                        id: 1,
                        label: "20 participants",
                        value: "20 participants",
                      },
                    ]}
                    noIcon
                    noMt
                  />
                </Grid2> */}
                <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Start Date" required />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        eventFormData.startDateTime
                          ? dayjs(eventFormData.startDateTime)
                          : null
                      }
                      onChange={(value) =>
                        handleEventFormChange("startDateTime", value)
                      }
                      sx={{
                        height: "52.5px",
                        width: "100%",
                        borderRadius: "0px",
                        border: "1px solid #000",
                      }}
                    />
                  </LocalizationProvider>
                </Grid2>
                {/* ✅ Checkbox for One-Time or Recurring Event */}
                <Grid2 item size={{ xs: 12, md: 6 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!eventFormData.oneTimeEvent}
                        onChange={(e) =>
                          handleEventFormChange(
                            "oneTimeEvent",
                            !e.target.checked
                          )
                        }
                      />
                    }
                    label="Repeat Event"
                  />
                </Grid2>
                {/* ✅ Show Recurrence Options ONLY if it's a Recurring Event */}
                {!eventFormData.oneTimeEvent && (
                  <>
                    {/* Select Recurrence Type (Daily, Weekly, By Date) */}
                    <Grid2 item size={{ xs: 12, md: 6 }}>
                      <CustomInputLabel text="Repeat Every" required />
                      <CustomDropDown
                        value={eventFormData.recurrenceType}
                        setValue={(value) =>
                          handleEventFormChange("recurrenceType", value)
                        }
                        title="Select Repeat Type"
                        label="Select Repeat Type"
                        data={[
                          { value: "daily", label: "Day" },
                          { value: "weekly", label: "Week" },
                          { value: "byDate", label: "By Date" },
                        ]}
                        noIcon
                        noMt
                      />
                    </Grid2>

                    {/* Recurrence End Date (Optional) */}
                    <Grid2 item size={{ xs: 12, md: 6 }}>
                      <CustomInputLabel text="Repeat Until" required />
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={
                            eventFormData.recurrenceEndDate
                              ? dayjs(eventFormData.recurrenceEndDate)
                              : null
                          }
                          onChange={(value) =>
                            handleEventFormChange("recurrenceEndDate", value)
                          }
                          sx={{
                            height: "52.5px",
                            width: "100%",
                            borderRadius: "0px",
                            border: "1px solid #000",
                          }}
                        />
                      </LocalizationProvider>
                    </Grid2>
                  </>
                )}
              </Grid2>
            </Grid2>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                pb: "70px",
                width: "100%",
                gap: 1,
              }}
            >
              <SecondaryBtn
                onClick={() => navigate("/calendar")}
                text="Close"
                Icon={Close}
                noMb
                noMt
                width="50%"
              />
              <SecondaryBtn
                onClick={event ? handleUpdateEvent : handleCreateEvent}
                text={event ? "Edit" : "Create"}
                noMb
                Icon={ArrowForward}
                noMt
                width="50%"
                filled
              />
            </Box>
          </Grid2>
        </Box>
      </Box>
    </Layout>
  );
};

export default CreateExerciseEvent;
